import { render } from "./correctionNote.vue?vue&type=template&id=bab882a4&scoped=true"
import script from "./correctionNote.vue?vue&type=script&lang=js"
export * from "./correctionNote.vue?vue&type=script&lang=js"

import "./correctionNote.vue?vue&type=style&index=0&id=bab882a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab882a4"]])

export default __exports__